





















































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {PeditForm} from "@/form/ProductForm";
import productModule from '@/store/module/ProductModule';
import EditDialog from "@/component/Crud/edit-dialog.vue";
import ProductApi from "@/module/device/ProductApi";
import {Container} from "typescript-ioc";
import Product from "@/model/Product";
import RefreshButton from "@/component/Button/refresh-button.vue";
import CategorySelect from "@/component/Thing/category-select.vue";
import {NetConfigMode} from "@/module/device/NetConfigMode";

@Component({
  components: {
    RefreshButton,
    EditDialog,
    CategorySelect,
  },
})
export default class ProductInfoView extends Vue {

  private productApi = Container.get(ProductApi)

  @Ref()
  private editDialog!: EditDialog

  private form = new PeditForm()

  private product = new Product()

  @Ref()
  private categorySelect!: CategorySelect

  private NetConfigMode = NetConfigMode

  private async created() {
    await this.getProduct()
  }

  private async getProduct() {
    const id = productModule.activeOrNull?.id ?? Number(this.$route.query.pid)
    this.product = await this.productApi.query(id)
    await productModule.activate(this.product)
  }

  private refresh() {
    this.getProduct()
  }

  private async handleEditClick() {
    await this.editDialog.open()
    this.categorySelect.refresh()
  }

  private async beforeOpenEditDialog() {
    this.form.id = this.product.id
    this.form.name = this.product.name
    this.form.description = this.product.description
    this.form.icon = this.product.icon
    this.form.natureKey = this.product.natureKey
    this.form.netConfigMode = this.product.netConfigMode
    this.form.categoryId = this.product.category.id
  }

  private async editProduct() {
    const product = await this.productApi.edit(this.form)
    productModule.activate(product)
    this.$bus.$emit('product:update')
  }
}
